<template>
  <div
    id="app"
    data-col="1-column"
    class="kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--fixed kt-subheader--enabled kt-subheader--solid kt-aside--enabled kt-aside--fixed kt-page--loading"
  >
    <Header/>
    <div class="kt-grid kt-grid--hor kt-grid--root">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
        <Navbar/>
        <div
          class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
          style="padding-top: 50px;"
        >
          <router-view :style="{ 'min-height': $store.state.screenHeight - 110.5+ 'px' }"></router-view>
          <Footer/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Header from '../components/layout/header'
import Navbar from '../components/layout/navbar'
import Footer from '../components/layout/footer'
export default {
  name: 'app',
  components: {
    Header,
    Navbar,
    Footer
  },
  mounted () {
    if (this.checkPermission() < 0) {
      // if (this.$route.name !== 'home') {
      //   this.$router.push({ name: 'P404' })
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue